import React from "react";

import { IconButton, Menu, MenuItem } from "@mui/material";

import {
  MoreHoriz as MoreIcon,
  VisibilityOutlined as ViewIcon,
  DescriptionOutlined as ManageIcon,
  Delete,
} from "@mui/icons-material";
import { useSelector } from "react-redux";
import { PrintIcon } from "../../../assets/icons/icons";
import { useQueryParams } from "../../../hooks/useQueryParams";

const DocumentGeneralJournalAdjustingActions = ({
  data,
  onDelete = () => {},
  onView = () => {},
  onManage = () => {},
  onPrint = () => {},
}) => {
  const [anchor, setAnchor] = React.useState(null);
  const user = useSelector((state) => state.user);
  const { searchParams } = useQueryParams();
  const is_posted = searchParams.get("is_posted");

  const actionOpenHandler = (event) => {
    setAnchor(event.currentTarget);
  };

  const actionCloseHandler = () => {
    setAnchor(null);
  };

  return (
    <React.Fragment>
      <IconButton size="small" onClick={actionOpenHandler}>
        <MoreIcon />
      </IconButton>

      <Menu
        open={Boolean(anchor)}
        elevation={2}
        anchorEl={anchor}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        MenuListProps={{
          sx: { py: 0.5 },
        }}
        onClose={actionCloseHandler}
        disablePortal
      >
        {/* {Boolean(Number(is_posted)) || user?.position?.toUpperCase() === "SUPERVISOR" ? (
          <MenuItem
            sx={{ fontWeight: 500 }}
            onClick={() => {
              onView(data);
              actionCloseHandler();
            }}
            dense
          >
            <ViewIcon sx={{ fontSize: 21, marginRight: 1, opacity: 0.75 }} /> View
          </MenuItem>
        ) : null} */}
        {Boolean(Number(is_posted)) ? (
          <MenuItem
            sx={{ fontWeight: 500 }}
            onClick={() => {
              onPrint(data);
              actionCloseHandler();
            }}
            dense
          >
            <PrintIcon sx={{ fontSize: 21, marginRight: 1, opacity: 0.75 }} /> Print
          </MenuItem>
        ) : null}

        <MenuItem
          sx={{ fontWeight: 500 }}
          onClick={() => {
            onView(data); // if revert, change to onManage
            actionCloseHandler();
          }}
          dense
        >
          {/* if revert, change to Manage  */}
          <ManageIcon sx={{ fontSize: 21, marginRight: 1, opacity: 0.75 }} /> View
        </MenuItem>

        {!Boolean(Number(is_posted)) ? (
          <MenuItem
            sx={{ fontWeight: 500 }}
            onClick={() => {
              onDelete(data.id);
              actionCloseHandler();
            }}
            dense
          >
            <Delete sx={{ fontSize: 21, marginRight: 1, opacity: 0.75 }} /> Delete
          </MenuItem>
        ) : null}
      </Menu>
    </React.Fragment>
  );
};

export default DocumentGeneralJournalAdjustingActions;
